// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609301006/js/" + chunkId + "." + {"44":"21957b28","225":"e44141b8","481":"ba748b48","486":"a0b4b1f9","770":"8cfb80e9"}[chunkId] + ".0.579454604121888.chunk.js";
};